import { Component, ComponentInterface, h, Host, JSX, Prop } from '@stencil/core';
import { transformTagNames } from '../../global/transform-tag-name';

/**
 * @slot - contents placed within the navigation item
 * @slot icon - icon placed in the start of the navigation item
 */
@Component({
  tag: 'wb-header-navigation-item',
  styleUrl: 'header-navigation-item.scss',
  shadow: true,
})
export class HeaderNavigationItemComponent implements ComponentInterface {
  /** renders an anchor tag linked to the passed in URL */
  @Prop()
  public href?: string;

  /** can be used in combination with `href` property */
  @Prop()
  public download?: string;

  /** can be used in combination with `href` property */
  @Prop()
  public rel?: string;

  /** can be used in combination with `href` property */
  @Prop()
  public target?: string;

  /** marks the navigation item as active */
  @Prop({ reflect: true })
  public active: boolean;

  /** @internal used for styling */
  @Prop({ reflect: true, mutable: true })
  public hasIcon: boolean = false;

  private TagNames = transformTagNames(this, 'wb-header-navigation-item', ['wb-text']);

  private updateHasIcon = (e: Event) => {
    this.hasIcon = (e.target as HTMLSlotElement).assignedElements().length > 0;
  };

  public render(): JSX.Element {
    const { WbText } = this.TagNames;

    return (
      <Host class="wb-header-navigation-item">
        {this.href ? (
          <a href={this.href} target={this.target} rel={this.rel} download={this.download} class="trigger">
            <slot name="icon" onSlotchange={this.updateHasIcon} />
            <WbText size="l" static class="label">
              <slot />
            </WbText>
          </a>
        ) : (
          <button type="button" class="trigger">
            <slot name="icon" onSlotchange={this.updateHasIcon} />
            <WbText size="l" static class="label">
              <slot />
            </WbText>
          </button>
        )}
      </Host>
    );
  }
}
